import {MBenefitsHoverCard} from "@/pages/common/Home/Overview/BenefitsHoverCard";

import React from "react";

import {motion} from "framer-motion";
import {useSelector} from "react-redux";

import styles from "./styles.module.scss";

const itemAnimation = {
  hidden: {opacity: 0},
  visible: (custom) => ({
    opacity: 1,
    transition: {
      delay: custom * 0.3,
    },
  }),
};

export const Benefits = (props) => {
  const {items, itemBackColor, itemChild, itemHover} = props;
  const {isMobile} = useSelector((state) => state.common.settings);

  return (
    <motion.div
      initial={"hidden"}
      whileInView={"visible"}
      viewport={{amount: 0.25, once: true}}
      className={styles.benefits}
      style={{
        "--itemChild": itemChild,
        "--itemBackColor": itemBackColor,
        "--itemHover": itemHover,
      }}
    >
      {items &&
        items.length > 0 &&
        items.map((item, index) => (
          <React.Fragment key={item.id}>
            <MBenefitsHoverCard
              custom={item.id + 1}
              variants={!isMobile ? itemAnimation : undefined}
              item={item}
              index={index}
              itemChild={itemChild}
            />
          </React.Fragment>
        ))}
    </motion.div>
  );
};
